module.exports = __webpack_public_path__ + "static/media/persik.4e1ec840.png";